import { useEffect } from 'react'
import {
  Navigate,
  Outlet,
  useSearchParams,
  ScrollRestoration,
} from 'react-router-dom'
import { routes } from '@/router'
import { useValidateSession } from '@/api/user-manager'
import { clearStoragePreservingAnnouncements } from '@/helpers'
import { Loading } from '../loading'

export function PrivateRoute() {
  const [searchParams, setSearchParams] = useSearchParams()

  const searchParamToken = searchParams.get('token')

  if (searchParamToken) {
    localStorage.setItem('access_token', searchParamToken)
  }

  const { error, isSuccess: isValidToken, isLoading } = useValidateSession()

  useEffect(() => {
    if (isValidToken) {
      searchParams.delete('token')
      setSearchParams(searchParams)
    }
  }, [isValidToken])

  useEffect(() => {
    if (error) {
      clearStoragePreservingAnnouncements()
    }
  }, [error])

  if (isLoading) {
    return <Loading />
  }

  return isValidToken ? (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  ) : (
    <Navigate to={routes.session.signin} />
  )
}
